__turbopack_context__.v({
  "announcement-bar": "announcement-bar-module__qR-VUG__announcement-bar",
  "announcement-bar--marquee": "announcement-bar-module__qR-VUG__announcement-bar--marquee",
  "announcement-bar-marquee": "announcement-bar-module__qR-VUG__announcement-bar-marquee",
  "announcement-bar__inner": "announcement-bar-module__qR-VUG__announcement-bar__inner",
  "announcement-bar__item": "announcement-bar-module__qR-VUG__announcement-bar__item",
  "announcement-bar__item--marquee": "announcement-bar-module__qR-VUG__announcement-bar__item--marquee",
  "announcement-bar__list": "announcement-bar-module__qR-VUG__announcement-bar__list",
  "announcement-bar__list--marquee": "announcement-bar-module__qR-VUG__announcement-bar__list--marquee",
  "announcement-bar__separator": "announcement-bar-module__qR-VUG__announcement-bar__separator",
  "announcement-bar__separator-icon": "announcement-bar-module__qR-VUG__announcement-bar__separator-icon",
  "announcement-bar__text": "announcement-bar-module__qR-VUG__announcement-bar__text",
});
